// extracted by mini-css-extract-plugin
export var footer = "_mn-5";
export var fulfillmentInput = "_mn-0";
export var shipDateInput = "_mn-1";
export var shipmentModal = "_mn-2";
export var shipmentModalContent = "_mn-3";
export var tableContainer = "_mn-4";